import React from 'react';
import { useTranslation } from 'react-i18next';
import LAdmin from '../layouts/LAdmin';
import { Helmet } from 'react-helmet';
import CAppTitle from '../../../app/components/CAppTitle';
import FAdminDocumentEmailNotifications from '../features/document-email-notifications/FAdminDocumentEmailNotifications';
import langAdminDocumentEmailNotifications from '../langs/langAdminDocumentEmailNotifications';

const PAdminDocumentEmailNotifications = () => {
	const { t } = useTranslation();
	return (
		<LAdmin>
			<Helmet>
				<title>IRP Admin tools - {t(langAdminDocumentEmailNotifications.title.tag)}</title>
			</Helmet>
			<CAppTitle
				title={t(langAdminDocumentEmailNotifications.title.tag)}
				id="title-admin-document-emails-notifications"
			/>
			<FAdminDocumentEmailNotifications />
		</LAdmin>
	);
};

export default PAdminDocumentEmailNotifications;
